import SkipToMainContentLink from './SkipToMainContentLink';

export default SkipToMainContentLink;
